export default "__VITE_ASSET__c33cfae4__"